import { Component, OnInit } from '@angular/core';
import { NgxCarousel, NgxCarouselStore } from 'ngx-carousel';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperNavigationInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { Title, Meta} from '@angular/platform-browser';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})

export class ServicesComponent implements OnInit {
  public carouselHeader: NgxCarousel;
  public carouselAudit: NgxCarousel;

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    effect: 'fade',
    spaceBetween: 300,
    loop: true
  };

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: false
  };

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.carouselHeader = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 2000,
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner',
      easing: 'ease',
      animation: 'lazy',
    };

    this.carouselAudit = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner',
      easing: 'ease',
      animation: 'lazy',
    };

    if (this.translate.currentLang === 'en') {
      this.titleService.setTitle('Voyager - Premium services');
      this.metaService.addTags([
        { name: 'description', content: 'Voyager offers a host of high-end services like restaurant, cafeteria, auditorium, business center or even a fitness area.' },
        { name: 'keywords', content: 'Lunch, restaurant, fitness, services, business, center, cafeteria, auditorium, restaurant' }
      ]);
    } else if (this.translate.currentLang === 'fr') {
      this.titleService.setTitle('Voyager- Tous les services dans l\'immeuble Voyager');
      this.metaService.addTags([
        { name: 'description', content: 'Voyager dispose de nombreux services comme un restaurant et une cafétéria, un business center, un auditorium et une salle de sport. De nombreuses terrasses ponctuent différents étages pour un bien être total.' },
        { name: 'keywords', content: 'restaurant, sport, fitness, bien-être, services, bureaux, business center, auditorium, cafétéria, café, pause, restaurant, RIE' }
      ]);
    }



    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (this.translate.currentLang === 'en') {
        this.titleService.setTitle('Voyager - Premium services');
        this.metaService.updateTag({
          name: 'description',
          content: 'Voyager offers a host of high-end services like restaurant, cafeteria, auditorium, business center or even a fitness area.'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Lunch, restaurant, fitness, services, business, center, cafeteria, auditorium, restaurant'
        });
      } else if (this.translate.currentLang === 'fr') {
        this.titleService.setTitle('Voyager- Tous les services dans l\'immeuble Voyager');
        this.metaService.updateTag({
          name: 'description',
          content: 'Voyager dispose de nombreux services comme un restaurant et une cafétéria, un business center, un auditorium et une salle de sport. De nombreuses terrasses ponctuent différents étages pour un bien être total. '
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'restaurant, sport, fitness, bien-être, services, bureaux, business center, auditorium, cafétéria, café, pause, restaurant, RIE'
        });
      }
    });
  }
  public myfunc(event: Event) {

  }


}



// WEBPACK FOOTER //
// ./src/app/services/services.component.ts